
import { DataType } from "@dndModels/Types";
import { ModelBase } from "@models/UpsertableBase";

/**
 * This is a type of Feature with a little more
 * dynamics to it.  
 * Think Feature that has Features.  
 * Like a FeatureBase, but an extra level.
 * 
 * Also it gets saved to its own collection,
 * and generally when it's used as a Feature 
 * the_feature will just contain the type.
 * CharacterFeature will let the user choose
 * the specific option they want based on the type.
 * 
 * Part of why it's going to its own collection
 * is that some of these can show up in different 
 * places (like class features and feats).
 * 
 * Eldritch Invocations and Pact Boons could
 * be shoehorned into this, but I think it's best
 * not to because of how Invocations often have
 * Boons as prereqs.
 * 
 * I am going to use this for Totem Attunements,
 * Maneuvers, and Metamagic.  
 * I'll probably find other uses as well.
 */
export class Tool extends ModelBase {
  data_type: DataType = "tool";
  type: string;

  get tool_type() {
    return this.type;
  }

  constructor(obj?: any) {
    super(obj);
    this.type = obj ? `${obj.type}` : "";
  }
  
  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      type: this.type
    };
  }

  toLight(): any {
    return {
      ...super.toLight(),
      type: this.type
    };
  }

  copy(copyMe: Tool, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.type = copyMe.type;
  }

  clone(drop_ids = false): Tool {
    const new_obj = new Tool();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}